import React, { useState } from 'react';
import { Field, withTypes } from 'react-final-form';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Spinner } from 'reactstrap';
import CustomInputField from '../../../components/form/CustomInputField';
import Icon from '../../../assets/icons/Icon';
import NotificationBanner from './NotificationBanner';
import { useDict, useLanguageUpdate } from '../../../contexts/LanguageContext';
import { postLogin } from '../src/authApis';
import ROUTE_NAME from '../../../routes/RouteName';

const LogInForm = () => {
    const dict = useDict();

    const navigate = useNavigate();

    const [isShowPassword, setIsShowPassword] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const showPassword = (e) => {
        e.preventDefault();
        setIsShowPassword(!isShowPassword);
    };

    const { Form } = withTypes();

    const loginValidation = (values) => {
        const errors = {};
        if (!values.username) {
            errors.username = dict.emailEmpty;
        }
        if (!values.password) {
            errors.password = dict.passwordEmpty;
        }
        return errors;
    }

    const handleSubmit = async (values) => {
        setIsLoading(true);

        values = {
            second_step: 0,
            ...values,
        }

        sessionStorage.setItem('email', values.username);

        await postLogin(values, () => { navigate(ROUTE_NAME.TWO_FACTOR_AUTH) });

        setIsLoading(false);
    }

    return (
        <>
            <NotificationBanner />
            <Form
                initialValues={{
                    username: '',
                    password: '',
                }}
                validate={loginValidation}
                onSubmit={(values) => { handleSubmit(values) }}
            >
                {({ handleSubmit }) => (
                    <form className="form" onSubmit={handleSubmit}>
                        <div className="form__form-group">
                            <span className="form__form-group-label" />
                            <div className="form__form-group-field">
                                <Field name="username">
                                    {({ input, meta }) => (
                                        <CustomInputField
                                            input={input}
                                            meta={meta}
                                            type="email"
                                            placeholder={dict.email}
                                            data-cy="login__username"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field" style={{}}>
                                <Field name="password">
                                    {({ input, meta }) => (
                                        <CustomInputField
                                            input={input}
                                            meta={meta}
                                            type={
                                                isShowPassword
                                                    ? 'text'
                                                    : 'password'
                                            }
                                            placeholder={dict.password}
                                            data-cy="login__password"
                                        />
                                    )}
                                </Field>
                                <span
                                    className={`form__form-group-button ${isShowPassword ? ' active' : ''
                                        } form__form-group-button--show-password`}
                                    onClick={(e) => showPassword(e)}
                                    onKeyDown={(e) => showPassword(e)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <Icon
                                        icon={
                                            isShowPassword ? 'Eye' : 'EyeSlash'
                                        }
                                    />
                                </span>
                            </div>
                            <div className="account__forgot-password">
                                <Link to={ROUTE_NAME.FORGOT_PASSWORD}>
                                    {dict.forgotPassword}
                                </Link>
                            </div>
                        </div>
                        <div className="account__btns">
                            <Button
                                color="primary"
                                className="btn account__btn rounded"
                                type="submit"
                                style={{ margin: '10px 10px 20px 10px' }}
                                data-cy="login__loginBtn"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <Spinner size="sm" color="orange" />
                                ) : (
                                    dict.signIn
                                )}
                            </Button>{' '}
                            &nbsp;
                            <Button
                                color="primary"
                                type="button"
                                className="btn btn-outline-primary account__btn btn-register rounded"
                                onClick={() => navigate(ROUTE_NAME.REGISTRATION)}
                                disabled={isLoading}
                                data-cy="login__registerBtn"
                            >
                                {dict.register}
                            </Button>
                        </div>
                    </form>
                )}
            </Form>
        </>
    );
};

export default LogInForm;
